import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import type { ITkMemoProps } from "../../../type/componentsType/TkMemo";
import TkCheckbox from "../../atoms/TkCheckbox";
import TkFakeTableLine from "../../atoms/TkFakeTableLine";
import TkTable from "../../atoms/TkTable";
import "./_style.scss";

/**
 * メモ部品
 * @param {ITkMemoProps} props - コンポーネントのプロパティ
 * @param {Array} props.headList - テーブルヘッダーセルのリスト
 * @param {Array} props.bodyList - テーブルボディーセルのリスト
 * @param {boolean} props.showTable テーブルの表示有無
 * @param {boolean} props.showCheckBox チェックボックスの表示有無
 * @returns TkMemo メモ部品
 */
export const TkMemo: React.FC<ITkMemoProps> = (props) => {
  const {
    headList,
    bodyList,
    showTable = true,
    showCheckBox = true,
    disabledCheckBox = false,
    onChange,
    inputProps,
    wantToSetValue,
    ...rest
  } = props;

  const [useBodyList, setUseBodyList] = useState(bodyList);

  useEffect(() => {
    if (!bodyList) return;
    if (!bodyList.length) return;
    const modifiedBodyList = bodyList.map((row) => {
      if (row[3] && row[3].children) {
        return [
          ...row.slice(0, 3),
          {
            ...row[3],
            children: (
              <div
                dangerouslySetInnerHTML={{
                  __html: row[3].children.replace(/\n/g, "<br />"),
                }}
              />
            ),
          },
        ];
      }
      return row;
    });
    setUseBodyList(modifiedBodyList);
  }, [bodyList]);

  const headListData = [
    { headTitle: "担当者" },
    { headTitle: "処理" },
    { headTitle: "実施日" },
    { headTitle: "コメント" },
  ];
  const handleChange = (
    type: string,
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = {
      target: {
        value: type === "input" ? e.target.value : e.target.checked,
        type: type,
      },
    };
    onChange && onChange(value);
  };

  return (
    <Box className="tkMemo">
      {showTable && useBodyList?.length ? (
        <Box className="table">
          <Box>処理履歴</Box>
          <TkTable
            {...rest}
            headList={headList || headListData}
            bodyList={useBodyList}
          />
        </Box>
      ) : (
        <></>
      )}
      <Box className="table">
        <Box>メモ</Box>
        <TkFakeTableLine
          data-testid="TkFakeTableLineTestid"
          {...rest}
          title={"メモ"}
          onChange={(e: any) => handleChange("input", e)}
          InputProps={{
            inputProps: { maxLength: 500, "data-testid": "TkMemoInput" },
          }}
          setDefaultValue={wantToSetValue}
          onlyFullWidth={true}
        />
      </Box>
      {showCheckBox && (
        <Box>
          <TkCheckbox
            data-testid="TkMemoCheckbox"
            label="照会画面への反映"
            {...rest}
            onChange={(e: any) => handleChange("checkbox", e)}
            disabled={disabledCheckBox}
          />
        </Box>
      )}
    </Box>
  );
};
export default TkMemo;
